/* ⚛ REACT */
import { useEffect, useRef, useState } from "react";

/* 📦 LIBS */
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

/* 🧩 COMPONENTS */
import { Button, Input, Label, Modal, Pagination, CustomLoading, SaveIcon } from "../../../../Components";

/* 🔗 SERVICE */
import {  EquipamentTypesServices } from "../../../../Services/equipamentosServices/types";

/* 🧠 REDUX */
import { store } from "../../../../Redux/Store";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { changeModal } from "../../../../Redux/Actions";

/* 📁 ASSETS*/
import { Lupa } from "../../../../Assets/icons";

/* 🎨 STYLES */
import { CountContainer, LineTitle, TitleText, LineList, ListText, PageTitle, ContainerList, HeaderContainer, InputContainer, FilterInput, 
    ContainerHead, ContainerRow, ButtonsContainer, ContainerColumn } from "../../../styles";

/* 🔧 UTILS */
import { isValidField } from "../../../../util/validate";

const EquipmentTypeList = () => {
    // const navigate = useNavigate();
    const { t } = useTranslation();

    document.title = t("administrative.sub-items.equipments-types.list.document-title");

    const Services = useRef(new EquipamentTypesServices());
    
    const NameField = useRef();
    
    const NameValue = useRef();
    const timeOutComunicationValue = useRef();
    const observationValue = useRef();
    const ModelValue = useRef();
    const searchValue = useRef();
    
    const [list, setList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    let active = useSelector(state => state.ModalReducer.name);

    // Busca os grupos de equipamentos
    const getList = async() => {
        setIsLoading(true);
        let currentList = await Services.current.getAllEquipmentTypes();
        setList(currentList);
        setIsLoading(false);
    }


    useEffect(() => {
        getList();
    }, []);

    const aplyFilter = async() => {
        setIsLoading(true);
        let currentList = await Services.current.getAllEquipmentTypes(searchValue.current);
        setList(currentList);
        setIsLoading(false);
    }

    // Salva as edições do usuário
    async function Save(){
        if(isValidField(NameValue.current) && isValidField(ModelValue.current)){
            let form = {};
                
            if(NameValue.current){form.name = NameValue.current}
            if(timeOutComunicationValue.current){form.communication_timeout_minutes = timeOutComunicationValue.current}
            if(observationValue.current){form.observation = observationValue.current}
            if(ModelValue.current){form.equipable_type = ModelValue.current}

            await Services.current.SaveEquipmentType(form);
            store.dispatch(changeModal(''));
        }else{
            toast(t("message.save"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
    }

    const changePage = async(page) => {
        setIsLoading(true);
        let currentList = await Services.current.getAllEquipmentTypes(searchValue.current, page);
        setList(currentList);
        setIsLoading(false);
    }

    return(
        <>
            <PageTitle>
                {t("administrative.sub-items.equipments-types.list.page-title")}
            </PageTitle>

            <HeaderContainer>
                <InputContainer>
                    <img src={Lupa} alt={t("inputs.search-group.alt")}></img>
                    <FilterInput
                        // onBlur={()=>Aplyfilter()}
                        onKeyDown={(e) => e.key === 'Enter' && aplyFilter()}
                        onChange={(e) => searchValue.current = e.target.value}
                        placeholder={t("inputs.search-group.placeholder")}
                    />
                </InputContainer>

                <Button width={'fit-content'} text={t("buttons.apply")} color={'green'} onClick={() => aplyFilter()}></Button>
            </HeaderContainer>
            
            <ContainerHead>
                <CountContainer>
                    {t("administrative.sub-items.list-total") + " " + list?.data?.length + " " + t("administrative.sub-items.equipments-types.list.equipment-types")}
                </CountContainer>
                
                <Button onClick={() => store.dispatch(changeModal('newgroup'))} width={'fit-content'} color={'green'} icon={''} text={t("buttons.register-equipment-type")}></Button>
            </ContainerHead>

            <ContainerList>
                <LineTitle $align="flex-start">
                    <TitleText>{t("header-table.name")}</TitleText>
                    <TitleText width={'40%'}>{t("header-table.communication_timeout_minutes")}</TitleText>
                    <TitleText>{t("header-table.observations")}</TitleText>
                </LineTitle>
                {isLoading?
                    <CustomLoading width={'150px'} height={'150px'}/>
                :
                    list?.data?.map((item) => (
                        <LineList $align="flex-start" key={item.id} href={`/adm/tipos-equipamentos/${item.id}`}>
                            <ListText>{item.name}</ListText>
                            <ListText width={'40%'}>{item.communication_timeout_minutes}</ListText>
                            <ListText>{item.observation}</ListText>
                        </LineList>
                    ))
                }
            </ContainerList>

            {isLoading?
                <></>
            :<Pagination last_page={list?.meta?.last_page} currentpage={list?.meta?.current_page} changepage={changePage}/>}
            
            <Modal title={t("modal.register-group.title")} name={'newgroup'} width={'70%'} height={'90%'} > 
                {active === 'newgroup' ?
                    <>
                        <ContainerRow onSubmit={(e) => e.preventDefault()}>
                            <ContainerColumn>
                                <Label text={t("inputs.name.label")} aling="flex-start"/>
                                <Input 
                                    aling="flex-start"
                                    id='name' 
                                    name='name' 
                                    type="text" 
                                    placeholder={t("inputs.name.placeholder")}
                                    innerRef={NameField}
                                    invalidMessage={t("inputs.name.invalid-message")}
                                    validationFunction={(text) => isValidField(text)}
                                    onchange={(text) => NameValue.current = text}> 
                                </Input>

                                <Label text={t("inputs.observations.label")} aling="flex-start"/>
                                <Input
                                    aling="flex-start"
                                    id='observation'
                                    name='observation'
                                    type="text"
                                    placeholder={t("inputs.observations.placeholder")}
                                    invalidMessage={t("inputs.observations.invalid-message")}
                                    validationFunction={(text) => isValidField(text)}
                                    onchange={(text) => observationValue.current = text}>
                                </Input>
                            </ContainerColumn>
                            
                            <ContainerColumn>
                                <Label text={t("inputs.timeout-comunication.label")} aling="flex-start"/>
                                <Input
                                    aling="flex-start"
                                    id='timeoutComunication'
                                    name='timeoutComunication'
                                    type="number"
                                    placeholder={t("inputs.timeout-comunication.placeholder")}
                                    invalidMessage={t("inputs.timeout-comunication.invalid-message")}
                                    validationFunction={(text) => isValidField(text)}
                                    onchange={(text) => timeOutComunicationValue.current = text}>
                                </Input>

                            </ContainerColumn>

                            <ContainerColumn>
                                <Label text={t("inputs.model.label")} aling="flex-start"/>
                                <Input
                                    aling="flex-start"
                                    id='model'
                                    name='model'
                                    type="text"
                                    placeholder={t("inputs.model.placeholder")}
                                    invalidMessage={t("inputs.model.invalid-message")}
                                    validationFunction={(text) => isValidField(text)}
                                    onchange={(text) => ModelValue.current = text}>
                                </Input>
                            </ContainerColumn>
                        </ContainerRow>

                        <ButtonsContainer>
                            <Button text={t("buttons.save")} width={'150px'} icon={<SaveIcon/>} onClick={() => Save()}/>
                            <Button text={t("buttons.cancel")} width={'150px'} color={'white-red'} onClick={() => store.dispatch(changeModal(''))}/>
                        </ButtonsContainer>
                    </>
                :<></>}
            </Modal>
        </>
    )
}

export default EquipmentTypeList;